module.exports = __webpack_public_path__ + "static/media/editService.dc48968a.png";